import type { FunctionComponent } from 'react';

import { LabeledCheckbox } from '../../../generic';
import Dropdown from '../../../settings/shared/SettingsPageDropdown';
import Section from '../../../shared/settings/SettingsPageSection';
import type { SelectOption } from '../../../../types';

import type { SBOMProjectSettings } from './useSBOMProjectSettings';

/**
 * ProjectSBOMPoliciesSettings component displays a settings section to configure the SBOM policy
 */
const ProjectSBOMPoliciesSettings: FunctionComponent<SBOMProjectSettings> = ({
  policyOptions,
  selectedPolicyOption,
  onSelectedPolicyChange,
  canEditPolicy,
  sbomAnalysisEnabled,
  setSBOMAnalysisEnabled,
}: SBOMProjectSettings) => {
  return (
    <Section>
      <Section.Left heading="SBOM">
        <Section.Paragraph>Configuration for the SBOMs imported to this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <Section.Heading>Scan for SBOM requirements</Section.Heading>
        <LabeledCheckbox
          label="Enable SBOM scanning"
          isChecked={sbomAnalysisEnabled}
          onChange={() => {
            setSBOMAnalysisEnabled(!sbomAnalysisEnabled);
          }}
          isDisabled={!canEditPolicy}
          isRippleDisabled
        />
        <Section.Paragraph>Enabling this will check for required fields and formats.</Section.Paragraph>
        <Section.Indented isDisabled={!sbomAnalysisEnabled}>
          <Dropdown
            id="settings-project-policies-sbom-policy"
            label="SBOM Policy"
            options={policyOptions}
            value={selectedPolicyOption}
            onChange={(option: SelectOption<string | number | null> | null) => {
              //  null is a valid value, it's how users can unset this.
              if (option?.value === null || option?.value) {
                // Because `policyOptions: SelectOption<number | null>`, we know that `option.value: number | null`
                onSelectedPolicyChange(option.value as number | null);
              }
            }}
            isDisabled={!canEditPolicy || !sbomAnalysisEnabled}
          />
        </Section.Indented>
      </Section.Right>
    </Section>
  );
};

export default ProjectSBOMPoliciesSettings;
